export default __webpack_public_path__ + "static/Hero-9d193935755c3f5ea39ffe0fbb596e81.webp";